(function () {
  if (customElements.get('trix-signup')) return;

  var KEY = 'trix_signup_v1';

  function stored() {
    try {
      return JSON.parse(localStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function save(patch) {
    try {
      var s = stored() || {};
      Object.keys(patch).forEach(function (k) {
        s[k] = patch[k];
      });
      localStorage.setItem(KEY, JSON.stringify(s));
    } catch (e) {}
  }

  class TrixSignup extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('.trix-signup__form');
      this.errorEl = this.querySelector('[data-error]');
      this.viewForm = this.querySelector('[data-view="form"]');
      this.viewDone = this.querySelector('[data-view="done"]');
      this.doneBody = this.querySelector('[data-done-body]');
      this.submitBtn = this.querySelector('.trix-signup__submit');
      this.labelEl = this.querySelector('[data-label]');
      this.defaultLabel = this.labelEl ? this.labelEl.textContent : 'Join';

      this.tab = document.getElementById('trix-signup-tab');

      this.querySelectorAll('[data-close]').forEach(
        function (el) {
          el.addEventListener('click', this.close.bind(this));
        }.bind(this)
      );

      if (this.tab) {
        this.tab.addEventListener('click', this.reopen.bind(this));
      }

      document.addEventListener(
        'keydown',
        function (e) {
          if (e.key === 'Escape' && this.hasAttribute('open')) this.close();
        }.bind(this)
      );

      if (this.form) this.form.addEventListener('submit', this.onSubmit.bind(this));

      if (window.Shopify && window.Shopify.designMode) {
        this.open();
        return;
      }

      var s = stored() || {};

      if (s.done) return;

      if (s.until && Date.now() < s.until) {
        this.showTab();
        return;
      }

      var delay = parseInt(this.dataset.delay || '4', 10) * 1000;
      setTimeout(this.open.bind(this), delay);
    }

    showTab() {
      if (!this.tab) return;
      this.tab.hidden = false;
      requestAnimationFrame(
        function () {
          this.tab.setAttribute('shown', '');
        }.bind(this)
      );
    }

    hideTab() {
      if (!this.tab) return;
      this.tab.removeAttribute('shown');
      setTimeout(
        function () {
          this.tab.hidden = true;
        }.bind(this),
        300
      );
    }

    open() {
      this.hideTab();
      this.hidden = false;
      requestAnimationFrame(
        function () {
          this.setAttribute('open', '');
        }.bind(this)
      );
    }

    reopen() {
      this.open();
    }

    close() {
      this.removeAttribute('open');
      var s = stored() || {};
      if (!s.done) {
        save({ until: Date.now() + parseInt(this.dataset.remind || '30', 10) * 86400000 });
        this.showTab();
      }
      setTimeout(
        function () {
          this.hidden = true;
        }.bind(this),
        400
      );
    }

    fail(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      this.submitBtn.disabled = false;
      if (this.labelEl) this.labelEl.textContent = this.defaultLabel;
    }

    succeed(size) {
      if (this.doneBody && size) {
        this.doneBody.textContent =
          'You are on the list for a ' + size + '. We will email you before the drop goes live.';
      }
      this.viewForm.hidden = true;
      this.viewDone.hidden = false;
      save({ done: true, until: Date.now() + 365 * 86400000 });
      this.hideTab();
    }

    onSubmit(e) {
      e.preventDefault();
      this.errorEl.hidden = true;

      var emailEl = this.querySelector('[data-email]');
      var sizeEl = this.querySelector('[data-size]');
      var email = emailEl.value.trim();
      var size = sizeEl.value;

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return this.fail('Enter a valid email address.');
      if (!size) return this.fail('Choose your size.');

      this.submitBtn.disabled = true;
      if (this.labelEl) this.labelEl.textContent = 'Sending...';

      var fd = new FormData();
      fd.append(emailEl.name, email);
      fd.append(sizeEl.name, size);

      var self = this;
      fetch(this.form.action, { method: 'POST', mode: 'no-cors', body: fd })
        .then(function () {
          self.succeed(size);
        })
        .catch(function () {
          self.fail('We could not save that. Check your connection and try again.');
        });
    }
  }

  customElements.define('trix-signup', TrixSignup);
})();
